module.exports = GroupCreator;

function GroupCreator () {}
GroupCreator.prototype = _.extend({}, Backbone.Events);
GroupCreator.prototype.constructor = GroupCreator;

GroupCreator.prototype.initialize = function () {
  var editor = INKIVE.Tool.getInstance().editor;
  this.canvas = editor.canvas;
};

GroupCreator.prototype.create = function (data) {
  data && data['link']
    ? this.canvas.groupSelectedElements(
      'a', INKIVE.Helpers.isUrlValid(data['link']) ? data['link'] : 'http://' + data['link']
    )
    : this.canvas.groupSelectedElements();

  var element = this.canvas.getSelectedElems()[0];
  this.trigger('', element.getAttribute('id'));

  return element.getAttribute('id');
};
